import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {/* Your content goes here */}
          <div>
            <div style={{ fontStyle: "italic" }}>
              Hi, we're Alluring Software.
              <br />
              We build native and web applications.
            </div>
            <br />
            <div style={{ fontSize: "1rem" }}>
              Contact us at{" "}
              <a href="mailto:info@alluring.dev">info@alluring.dev</a>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
